export const boardReminderTour = {
  key: "boardReminder",
  version: 1,
  getSteps: (t) => [
    {
      target: '.tour-reminder-add',
      content: t("Tour_BoardReminder_Add"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-reminder-bulk"]',
      content: t("Tour_BoardReminder_List"),
      placement: "top",
    },
    {
      target: '[data-tour="board-reminder-item"]',
      content: t("Tour_BoardReminder_Channel"),
      placement: "top",
    },
  ],
};
